import { useTLang } from 'intl/intl';

export function useSOHeaderDetailLang(productsCount: number) {
  return {
    title: useTLang({ id: 'scheduleOrder.detail.title' }),
    scheduledTag: useTLang({ id: 'scheduleOrder.scheduledTag' }),
    productsCount: useTLang(
      { id: 'scheduleOrder.detail.productsCount' },
      { count: productsCount },
    ),
  };
}
